/**
 * Eventos que citam uma cerca e levam o usuário a ela ao serem clicados.
 *
 * BUSINESS RULE: entrada, saída e excesso de velocidade, quando citam uma cerca (`geofenceId > 0`); ver
 * docs/notificacao-de-cerca.md.
 */
export const GEOFENCE_EVENT_TYPES = ['geofenceEnter', 'geofenceExit', 'deviceOverspeed'];

/**
 * @param {Object} event evento como o servidor entrega (`type`, `geofenceId`)
 * @return {boolean} `true` para entrada, saída ou excesso de velocidade que cita uma cerca (`geofenceId > 0`)
 */
export const isGeofenceEvent = (event) =>
  !!event && GEOFENCE_EVENT_TYPES.includes(event.type) && +event.geofenceId > 0;

/**
 * @param {Object[]|null} geofences cercas que o usuário vê, ou `null` enquanto a lista não chegou
 * @param {Object} event evento clicado
 * @return {Object|null} a cerca citada pelo evento; `null` quando o evento não é de cerca ou a cerca
 *   não está na lista (outra conta, apagada)
 */
export const findEventGeofence = (geofences, event) => {
  if (!geofences || !isGeofenceEvent(event)) return null;
  return geofences.find((g) => +g.id === +event.geofenceId) || null;
};

// Nem todo evento tem posicao: aparelho offline, resultado de comando e manutencao nascem sem uma, e
// o identificador chega como 0. Perguntar por ele devolve 400 e derrubava o desenho inteiro da tela.
// O mesmo 400 vem quando o evento cita uma posição que a limpeza já apagou; nos dois casos a tela segue
// sem a posição, só com a cerca e o dispositivo.
export const posicaoDoEvento = async (positionService, positionId) => {
  if (!positionId) return null;

  try {
    const posicoes = await positionService.getPositionsByIds([+positionId]);

    return (posicoes && posicoes[0]) || null;
  } catch (erro) {
    // Só o 400 é "posição inexistente"; rede caída ou 500 sobem para quem chamou tratar.
    if (erro && erro.status === 400) return null;
    throw erro;
  }
};
